/** Anchor 数据类型：输入/输出 */
export var INodePortConfigLinkType;
(function (INodePortConfigLinkType) {
    INodePortConfigLinkType["INPUT"] = "input";
    INodePortConfigLinkType["OUTPUT"] = "output";
})(INodePortConfigLinkType || (INodePortConfigLinkType = {}));
//# sourceMappingURL=interface.js.map